import { render, staticRenderFns } from "./edit-dialog.vue?vue&type=template&id=26077c7e&"
import script from "./edit-dialog.vue?vue&type=script&lang=ts&"
export * from "./edit-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports